<template>
  <div class="app-container">
    <el-card class="box-card">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="客户达标标准" name="1"></el-tab-pane>
        <el-tab-pane label="收款达标标准" name="2"></el-tab-pane>
        <el-tab-pane label="出货达标标准" name="3"></el-tab-pane>
      </el-tabs>
      <el-form ref="dataForm" :rules="formRules" :model="form" :inline="true">
        <div class="flex-box" v-if="yearStandardsList.length > 0">
          <el-form-item label="年达标标准：" prop="day">
            <el-date-picker v-model="yearValue" type="year" placeholder="年" size="small" @change="changeDate"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input placeholder="请输入" :disabled="yearStandardsList[0].isDisable" v-model="yearStandardsList[0].standardValue" size="small">
              <i slot="suffix" class="el-input__icon">万</i>
            </el-input>
          </el-form-item>
          <el-form-item label="实际业绩：">
            {{yearStandardsList[0].actualPerformance}}
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSave" size="mini">保存</el-button>
          </el-form-item>
        </div>
        <el-form-item label="每月达标标准：">
          <div class="moon-box">
            <el-row>
              <el-col class="moon-list" :span="2" :sm="2" :xs="4" v-for="(item,index) in moonStandardsList" :key="index">
                <p class="txt1">{{index + 1}}月(万)</p>
                <el-input v-model="item.standardValue" :disabled="item.isDisable" size="small" />
                <p class="txt2">实际业绩：{{item.actualPerformance}}</p>
              </el-col>
            </el-row>
          </div>
        </el-form-item>
        <el-form-item label="每周达标标准：">
          <div class="moon-box">
            <el-row>
              <el-col class="moon-list" :span="3" :sm="4" :xs="4" v-for="(item,index) in dayStandardsList" :key="index">
                <p class="txt1" style="">{{item.dateStr}}第{{index+ 1}}周(万)</p>
                <el-input v-model="item.standardValue" :disabled="item.isDisable" size="small" />
                <p class="txt2">实际业绩：{{item.actualPerformance}}</p>

              </el-col>
            </el-row>
          </div>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import complianceStandardsConfigApi from '@/api/config/complianceStandardsConfig'
import { getTimeStatus } from '@/utils/index'
export default {
  data() {
    return {
      activeName: '1',
      form: {

      },
      yearStandardsList: [],   //年达标标准
      moonStandardsList: [],   // 每月达标标准
      dayStandardsList: [],   // 每周达标标准
      yearValue: '',
      isRepSub: false,
    }
  },
  created() {
    this.yearValue = new Date()
    this.getYearStandards()
    this.getMoonStandards()
    this.getDayStandards()
  },
  methods: {
    handleClick() {
      this.getYearStandards()
      this.getMoonStandards()
      this.getDayStandards()
    },
    handleSave() {
      let params = this.clacParams()
      if (this.isRepSub) return
      this.isRepSub = true
      complianceStandardsConfigApi.create({ dateData: JSON.stringify(params) }).then((data) => {
        this.isRepSub = false
        this.$message.success('操作成功')
      }).catch(res => {
        this.isRepSub = false
      });
    },
    clacParams() {
      //type就是 1客户达标标准  2收款 3出货   
      // timeType 的类型 1日2周3月4季度5年
      // [{"type":1,"startTime":"2024-01-01 00:00:00","endTime":"2024-01-07 23:59:59","timeType":1,"standardValue":123},]
      let list = []
      this.yearStandardsList.forEach(item => {
        list.push({ type: +this.activeName, timeType: 5, startTime: item.startTime, endTime: item.endTime, standardValue: item.standardValue })
      })
      this.moonStandardsList.forEach(item => {
        list.push({ type: +this.activeName, timeType: 3, startTime: item.startTime, endTime: item.endTime, standardValue: item.standardValue })
      })
      this.dayStandardsList.forEach(item => {
        list.push({ type: +this.activeName, timeType: 2, startTime: item.startTime, endTime: item.endTime, standardValue: item.standardValue })
      })
      return list
    },
    changeDate() {
      this.getYearStandards()
      this.getMoonStandards()
      this.getDayStandards()
    },
    //获取年的数据
    getYearStandards() {
      let params = this.calcQuery(5)
      complianceStandardsConfigApi.fetchList(params).then(res => {
        res.data.forEach(item => {
          item.isDisable = getTimeStatus(item.startTime, item.endTime) === 3 ? true : false
        })
        this.yearStandardsList = res.data
      })
    },
    ////获取月的数据
    getMoonStandards() {
      let params = this.calcQuery(3)
      complianceStandardsConfigApi.fetchList(params).then(res => {
        res.data.forEach(item => {
          item.isDisable = getTimeStatus(item.startTime, item.endTime) === 3 ? true : false
        })
        this.moonStandardsList = res.data
      })
    },
    ////获取日的数据
    getDayStandards() {
      let params = this.calcQuery(2)
      complianceStandardsConfigApi.fetchList(params).then(res => {
        res.data.forEach(item => {
          item.dateStr = item.startTime.substr(5, 5) + '~' + item.endTime.substr(5, 5)
          item.dateStr = item.dateStr.replace(/\-/g, "/")
          item.isDisable = getTimeStatus(item.startTime, item.endTime) === 3 ? true : false
        });
        this.dayStandardsList = res.data
      })
    },
    calcQuery(timeType) {
      let year = this.yearValue.getFullYear()
      let params = {
        type: +this.activeName,
        timeType,
        startTime: year + '-01-01 00:00:00',
        endTime: year + '-12-31 23:59:59'
      }
      return params
    }
  }
}
</script>

<style lang="scss" scoped>
.flex-box {
  display: flex;
}
::v-deep .el-date-editor.el-input {
  width: 92px;
}
.moon-box {
  .moon-list {
    padding: 0;
    p {
      font-size: 14px;
      margin: 0;
      &.txt1 {
        text-align: center;
        background: #eff8fb;
        border-bottom: 1px solid #e5e5e5;
        color: #333;
      }
      &.txt2 {
        font-size: 12px;
      }
    }
    .el-input {
      padding-right: 20px;
    }
  }
}
::v-deep .el-input {
  border-color: #60b7dc;
  color: #60b7dc;
}
</style>